module.exports = __webpack_public_path__ + "images/jlks.9c79.png";